module.exports = __webpack_public_path__ + "6e2f4dcb984a74f9205156214fa999bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/expression-shock-s.png
// module id = 1809
// module chunks = 0